import { executeRequest, Request } from '@jfs/network'
import { getAPIURL, getPaymentHeader } from '../config'

/* New PG API */
export const upiValidateVpa = async (paymentInfo: any, deviceInfo: any) => {
  var deviceData = JSON.stringify(deviceInfo)
  const request: Request<{}> = {
    apiPath: `${getAPIURL('validateVpa')}`,
    method: 'POST',
    headers: {
      ...getPaymentHeader(),
      'x-device-info': deviceData,
    },
    body: paymentInfo,
  }
  return executeRequest(request)
    .then((data) => {
      return data
    })
    .catch((err) => {
      const {
        data: { error },
      } = err
      throw error
    })
}
